import { render, staticRenderFns } from "./edit_record.vue?vue&type=template&id=08a387c1&scoped=true&"
import script from "./edit_record.vue?vue&type=script&lang=js&"
export * from "./edit_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a387c1",
  null
  
)

export default component.exports